import { useState } from "react";
import { Img, DemoAction, Chip } from "./shared";

const MENU = {
  Vorspeisen: [["Rindsuppe mit Frittaten", "klare Kraftbrühe, Schnittlauch"], ["Saibling", "gebeizt, Kren, Gurke"], ["Burrata", "Paradeiser, Basilikumöl"]],
  Hauptgänge: [["Wiener Schnitzel", "vom Kalb, Erdäpfelsalat"], ["Rosa Rinderrücken", "Wurzelgemüse, Jus"], ["Risotto", "Steinpilze, Bergkäse"]],
  Desserts: [["Marillenknödel", "Butterbrösel, Staubzucker"], ["Schokolade", "Tonka, Weichsel"], ["Topfenschmarren", "Zwetschkenröster"]],
};

export default function Restaurant({ wide, onCta }) {
  const [cat, setCat] = useState("Hauptgänge");
  return (
    <div className="bg-[#2A1A12] text-[#F3E6D3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
      <section className={`relative ${wide ? "h-[560px]" : "h-[520px]"}`}>
        <Img k="food2" alt="Angerichteter Teller" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A1A12] via-[#2A1A12]/30 to-transparent" />
        <header className="absolute inset-x-0 top-0 flex items-center justify-between px-6 pt-12 text-[13px] tracking-[0.3em]" style={wide ? { paddingTop: 28, paddingLeft: 56, paddingRight: 56 } : undefined}>
          <span>ROSMARIN</span><span className="italic tracking-normal">Wirtshaus & Bar</span>
        </header>
        <div className={`absolute bottom-0 ${wide ? "left-14 pb-14 max-w-[560px]" : "left-6 right-6 pb-8"}`}>
          <p className="italic text-[#D9A86C]">seit jeher am Herd · eine Designstudie</p>
          <h1 className={`mt-2 font-medium leading-[0.95] ${wide ? "text-[72px]" : "text-[48px]"}`}>Saisonal.<br /><em>Herzlich.</em></h1>
        </div>
      </section>
      <section className={wide ? "grid grid-cols-2 gap-14 px-14 py-16" : "px-6 py-10"}>
        <div>
          <h2 className="text-[34px] italic">Speisekarte</h2>
          <div role="tablist" className="no-scrollbar mt-4 flex gap-5 overflow-x-auto border-b border-[#F3E6D3]/20" style={{ fontFamily: "'Jost Variable', sans-serif" }}>
            {Object.keys(MENU).map((c) => (
              <Chip key={c} active={cat === c} onClick={() => setCat(c)} activeCls="border-[#D9A86C] text-[#F3E6D3]" idleCls="border-transparent text-[#F3E6D3]/60" className="border-b-2 pb-2 text-[12px] uppercase tracking-[0.2em]">{c}</Chip>
            ))}
          </div>
          <ul className="mt-5 space-y-4">
            {MENU[cat].map(([n, d]) => (
              <li key={n} className="flex items-baseline gap-3">
                <div className="flex-1"><p className="text-[22px] leading-tight">{n}</p><p className="text-[15px] italic text-[#F3E6D3]/70">{d}</p></div>
              </li>
            ))}
          </ul>
        </div>
        <div className={wide ? "grid grid-cols-2 gap-4" : "mt-8 grid grid-cols-2 gap-3"}>
          <div className="aspect-[3/4] overflow-hidden rounded-t-full"><Img k="food4" alt="Gericht" /></div>
          <div className="aspect-[3/4] overflow-hidden translate-y-6"><Img k="restin2" alt="Gastraum" /></div>
        </div>
      </section>
      <section className={wide ? "px-14 pb-16" : "px-6 pb-12"}>
        <DemoAction label="Tisch reservieren" onCta={onCta} className="w-full rounded-full border border-[#D9A86C] py-3.5 text-[18px] italic text-[#F3E6D3]" />
      </section>
    </div>
  );
}
